import { Box, Flex } from '@chakra-ui/react';

import SkeletonComponent from 'UiKit/skeleton';
import { Iteration } from 'Component/others';

import styles from './styles.module.css';

const FilterSkeleton = () => {
  return (
    <Box className={styles['filter-skeleton__container']} data-testid="filter__skeleton">
      <Flex gap="8px">
        <SkeletonComponent height="28px" width="83%" />
        <SkeletonComponent height="28px" width="17%" />
      </Flex>
      <Flex gap="4px">
        <Iteration items={Array.from({ length: 5 })} render={() => <SkeletonComponent height="28px" width="30%" />} />
      </Flex>
    </Box>
  );
};

export default FilterSkeleton;
